<template>
  <div>
    <Cascader
      :options="list"
      @change="cascaderOnChange"
      :props="{ checkStrictly: true }"
      v-model="cascaderSelected"
      :filterable="true"
      :clearable="true"
      style="width:99%"
    ></Cascader>
    <div>
      <table
        v-if="electricInfo != null"
        class="table tabl-bordered table-striped mg-t-10-f mg-b-0-f"
      >
        <tbody>
          <tr>
            <td width="40%">Цахилгааны эх үүсвэр эзэмшигчийн мэдээлэл</td>
            <td>
              <h6>{{ electricInfo.ownerInfo }}</h6>
            </td>
          </tr>
          <tr>
            <td width="40%">Цахилгааны эх үүсвэр эзэмшигч</td>
            <td>
              <h6>{{ electricInfo.typeName }}</h6>
            </td>
          </tr>
          <tr>
            <td width="40%">Цахилгааний ХТП дугаар</td>
            <td class="">
              <h6>{{ electricInfo.htpNum }}</h6>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- {{ electricInfo }} -->
    </div>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { CascaderPanel, Cascader } from "element-ui";

var LTT = require("list-to-tree");

import { request } from "@/api/all";

export default {
  props: {
    locationId: {
      type: Number,
      default: () => 0
    },
    assetId: {
      type: Number,
      default: () => 0
    },
    mode: {
      type: Number,
      default: () => 1
    }
  },
  components: {
    CascaderPanel,
    Cascader
  },
  data() {
    return {
      listFlat: [],
      list: [],
      cascaderSelected: [],

      options: [
        {
          value: "s1",
          label: "songolt 1",
          children: [
            {
              value: "d1",
              label: "ded 1"
            }
          ]
        }
      ],
      selectedLocationId: null,
      electricInfo: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      request({
        params: {
          siteId: this.locationId > 0 ? this.locationId : null,
          getAllAsset: this.mode == 2 ? true : false
        },
        api: { url: "asset/AssetFlatListWithSite", method: "GET" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log(res);
          let dataTypes = res.data.list;
          this.listFlat = dataTypes;
          //console.log("get tree before");
          var ltt = new LTT(dataTypes, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.list = ltt.GetTree();
          //this.list=res.data.tree;
          //console.log("get tree after", this.list);

          if (this.locationId > 0 && this.assetId > 0) {
            this.cascaderModelRecursive(this.listFlat, this.assetId);
            this.cascaderSelected = this.cascaderSelected.reverse();
          } else if (this.locationId > 0) {
            this.cascaderModelRecursive(this.listFlat, this.locationId);
            this.cascaderSelected = this.cascaderSelected.reverse();
          } else this.cascaderSelected = [];
        }
      });
    },

    cascaderModelRecursive(data, cid) {
      this.cascaderSelected.push(cid);
      let pid = data.filter(d => d.id == cid)[0].parentId;
      if (pid > 0) {
        this.cascaderModelRecursive(data, pid);
      }
    },

    getSiteId(data, cid) {
      let findedData = data.filter(d => d.id == cid)[0];
      if (findedData.parentId == 0) {
        this.selectedLocationId = findedData.id;
      } else {
        this.getSiteId(data, findedData.parentId);
      }
    },

    cascaderOnChange(value) {
      let _id =
        value[value.length - 1] != undefined ? value[value.length - 1] : null;
      let _cur = this.listFlat.filter(x => x.id == _id);

      if (_cur.length > 0 && _cur[0].parentId > 0) {
        this.getSiteId(this.listFlat, _id);
        this.$emit("on-asset-changed", {
          locationId: this.selectedLocationId,
          assetId: _id
        });
        if (this.mode == 1) {
          request({
            params: { assetId: _id },
            api: { url: "asset/AssetElectricInfo", method: "GET" },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.electricInfo = res.data.info;
            } else this.electricInfo = null;
          });
        }
      } else {
        if (_cur.length > 0) {
          //console.log(_id);
          this.$emit("on-asset-changed", { locationId: _id, assetId: null });
        }

        this.$bvToast.toast("Тоног төхөөрөмж сонгоно уу !", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "warning",
          toaster: "b-toaster-bottom-left"
        });
      }
    }
  }
};
</script>

<style></style>
